import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import InputField from "common/customInputField";
import SelectInput from "common/selectInput";
import Button from "react-bootstrap/Button";
import SearchTable from "./searchTable";
import { useNavigate } from "react-router-dom";
import { searchProjectsFilter, isValidEmail } from "utils/common";
import { searchMqProjectsSubmit, searchMqProjectNameSubmit } from "store/siteRepo/actionCreator";
import { searchIsLoggedInUser, updateMqSearchProjectFields } from "store/slices/siteRepo";
import searchIcon from "svg/search.svg";
import warning from "svg/warning.svg";
import { toast } from "react-toastify";

const SelectProject = () => {
  const navigate = useNavigate();
  const filterDropdownRef = useRef();
  const dispatch = useDispatch();

  const { searchMqProjectsFields, showMqProjectSearchTable, isSearchOtherUser } = useSelector(
    (state) => state.siteRepo.createNewSite.searchMqProjects,
  );
  const { email } = useSelector((state) => state.loggedInUser);

  const handleMqProjectSearch = () => {
    if (searchMqProjectsFields.userEmail.length && !searchMqProjectsFields.projectSearch) {
      const isValidUserEmail = isValidEmail(searchMqProjectsFields.userEmail);
      if (!isValidUserEmail) {
        toast.error("Enter a valid email");
      } else {
        if (email?.toLowerCase() === searchMqProjectsFields.userEmail?.toLowerCase()) {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false }));
        } else {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: true }));
        }
        dispatch(searchMqProjectsSubmit({ searchMqProjectsFields, userId: searchMqProjectsFields.userEmail }));
      }
    } else if (searchMqProjectsFields.projectSearch.length && !searchMqProjectsFields.userEmail) {
      dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false }));
      dispatch(
        searchMqProjectNameSubmit({
          searchMqProjectsFields,
          userId: email,
          name: searchMqProjectsFields.projectSearch,
        }),
      );
    } else if (searchMqProjectsFields.projectSearch.length && searchMqProjectsFields.userEmail.length) {
      const isValidUserEmail = isValidEmail(searchMqProjectsFields.userEmail);
      if (!isValidUserEmail) {
        toast.error("Enter a valid email");
      } else {
        if (email?.toLowerCase() === searchMqProjectsFields.userEmail?.toLowerCase()) {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false }));
        } else {
          dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: true }));
        }
        dispatch(
          searchMqProjectNameSubmit({
            searchMqProjectsFields,
            userId: searchMqProjectsFields.userEmail,
            name: searchMqProjectsFields.projectSearch,
          }),
        );
      }
    } else {
      dispatch(searchIsLoggedInUser({ isLoggedInUserSearch: false }));
      dispatch(searchMqProjectsSubmit({ searchMqProjectsFields, userId: email }));
    }
  };

  const handleProjectTypeFilter = (e, value) => {
    const key = "projectType";
    dispatch(updateMqSearchProjectFields({ key, value }));
  };
  const handleChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    dispatch(updateMqSearchProjectFields({ key, value }));
  };

  const handleNextTab = () => {
    document.getElementById("site-details-tab").click();
  };

  return (
    <div className="select-project-container d-flex flex-column justify-content-between">
      <div className="search-form-container px-0 border-0">
        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row  mt-4 mt-md-0">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Project Name"
                  id="projectSearch"
                  placeholder="Enter a project name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={searchMqProjectsFields.projectSearch}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                  image={searchIcon}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 search-form-container__fields__form-group">
                {" "}
                <SelectInput
                  options={searchProjectsFilter}
                  label="Filter"
                  defaultValue="Select a filter"
                  value={searchMqProjectsFields.projectType.description}
                  inputRef={filterDropdownRef}
                  handleSelectInput={(e, value) => handleProjectTypeFilter(e, value)}
                  disabled={false}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Email"
                  id="userEmail"
                  placeholder="Enter user email"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={searchMqProjectsFields.userEmail}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
            </div>
          </form>
          <Button variant="primary" onClick={handleMqProjectSearch}>
            Search
          </Button>
        </div>
      </div>
      {showMqProjectSearchTable && isSearchOtherUser && (
        <div className="alert d-flex align-items-center" role="alert">
          <img src={warning} alt={"warning-icon"} />
          <div>
            You are searching projects for
            <b>{" " + searchMqProjectsFields.userEmail}</b>.
          </div>
        </div>
      )}
      {showMqProjectSearchTable && <SearchTable />}
      <div className="d-flex justify-content-between flex-column-reverse flex-md-row">
        <Button variant="outline-primary" onClick={() => navigate("/siteRepo")}>
          Back to site repository
        </Button>
        <Button className="m-0" variant="primary" onClick={() => navigate(`/siteRepo/createSite#site-details`)}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default SelectProject;
